export default {
  LK: {
    pageTitle: "Área pessoal",
    subscription: {
      yourSubs: "Sua assinatura",
      plan_1: "Gratuita",
      plan_2: "Avançada",
      plan_3: "Individual",
      changePlan: "Alterar plano",
      activeFor: "Ativa até",
      nextPayment: "Próximo pagamento",
      accessFor: "Acesso aberto até",
    },
    settings: "Configurações",
    form: {
      labels: {
        status: "Status",
        spec_med: "Especialidade",
        position: "Cargo",
        university: "Universidade",
      },
      spec_statValues: {
        doctor: "Médico",
        student: "Estudante",
        resident: "Residente",
        spec_med: "Funcionário de instituição médica",
      },
      /* eslint-disable prettier/prettier */
      spec_medValues: {
        "Obstetrician": "Obstetra",
        "Obstetrician-gynecologist": "Obstetra-ginecologista",
        "Allergist": "Alergista",
        "Angiosurgeon": "Angiologista",
        "Andrologist": "Andrologista",
        "Anesthetist": "Anestesista",
        "Anesthesiologist":"Anestesiologista",
        "Audiologist":"Audiologista",
        "Bacteriologist": "Bacteriologista",
        "Venereologist": "Venereologista",
        "Vertebrologist": "Vertebrologista",
        "Laboratory diagnostics doctor": "Médico de diagnóstico laboratorial",
        "Physiotherapy doctor": "Fisioterapeuta",
        "Magnetic resonance imaging doctor": "Especialista em ressonância magnética",
        "GP": "Clínico geral",
        "Sports medicine doctor": "Especialista em medicina esportiva",
        "Ultrasound diagnostic doctor": "Especialista em ultrassonografia",
        "Functional diagnostics doctor": "Especialista em diagnóstico funcional",
        "Dermatovenerologist": "Dermatovenerologista",
        "Dermatologist": "Dermatologista",
        "Pediatric gastroenterologist": "Gastroenterologista pediátrico",
        "Pediatric gynecologist": "Ginecologista pediátrico",
        "Pediatric cardiologist": "Cardiologista pediátrico",
        "Pediatric neurologist": "Neurologista pediátrico",
        "Child psychiatrist": "Psiquiatra infantil",
        "Pediatric dentist": "Dentista pediátrico",
        "Pediatric traumatologist-orthopedist": "Ortopedista pediátrico",
        "Pediatric urologist-andrologist": "Urologista-andrologista pediátrico",
        "Pediatric surgeon": "Cirurgião pediátrico",
        "Pediatric endocrinologist": "Endocrinologista pediátrico",
        "Nutritionist": "Nutricionista",
        "Other specialty": "Outra especialidade",
        "Immunologist": "Imunologista",
        "Infectious disease specialist": "Infectologista",
        "Cardiologist": "Cardiologista",
        "Kinesiotherapist": "Cinesioterapeuta",
        "Clinical Pharmacologist": "Farmacologista clínico",
        "Coloproctologist": "Coloproctologista",
        "Cosmetologist": "Cosmetologista",
        "Laboratory assistant": "Assistente de laboratório",
        "Speech therapist": "Fonoaudiólogo",
        "ENT (Otorhinolaryngologist)": "Otorrinolaringologista",
        "Mammologist": "Mastologista",
        "Chiropractor": "Quiroprático",
        "Masseur": "Massoterapeuta",
        "Nurse": "Enfermeira(o)",
        "Medical brother": "Enfermeiro",
        "Medical Director": "Diretor médico",
        "Mycologist": "Micologista",
        "Expert in narcology": "Narcologista",
        "Neurologist": "Neurologista",
        "Neurophysiologist": "Neurofisiologista",
        "Neurosurgeon": "Neurocirurgião",
        "Neonatologist": "Neonatologista",
        "Nephrologist": "Nefrologista",
        "Oculist (Ophthalmologist)": "Oftalmologista",
        "Oncologist": "Oncologista",
        "Orthopedist": "Ortopedista",
        "Osteopath": "Osteopata",
        "Parasitologist": "Parasitologista",
        "Periodontist": "Periodontista",
        "Pathologist": "Patologista",
        "Teacher": "Professor",
        "Pediatrician": "Pediatra",
        "Plastic surgeon": "Cirurgião plástico", 
        "Proctologist": "Proctologista",
        "Occupational pathologist": "Patologista ocupacional",
        "Psychiatrist": "Psiquiatra",
        "Psychiatrist-narcologist": "Psiquiatra-narcologista",
        "Psychologist": "Psicólogo",
        "Psychotherapist": "Psicoterapeuta",
        "Pulmonologist": "Pneumologista",
        "Radiolog": "Radiologista",
        "Rehabilitologist": "Reabilitador",
        "Reanimatologist": "Reanimatologista",
        "Rheumatologist": "Reumatologista",
        "Radiologist": "Radiologista",
        "Reproductologist (IVF)": "Especialista em reprodução (FIV)",
        "Reflexologist": "Reflexoterapeuta",
        "Sexologist": "Sexologista",
        "Cardiovascular surgeon": "Cirurgião cardiovascular",
        "Somnologist": "Especialista do sono",
        "Dentist": "Dentista",
        "Childrens-dentist": "Dentista pediátrico",
        "Dental hygienist": "Higienista dental",
        "Dentist-implantologist": "Implantodontista",
        "Dentist-orthodontist": "Ortodontista",
        "Orthopedic dentist": "Dentista ortopédico",
        "Dentist-therapist": "Dentista clínico",
        "Dental surgeon": "Cirurgião dentista",
        "Surdolog": "Audiologista",
        "Therapist": "Terapeuta",
        "Toxicologist": "Toxicologista",
        "Traumatologist": "Traumatologista",
        "Traumatologist-orthopedist": "Ortopedista-traumatologista",
        "Transplantologist": "Transplantologista",
        "Transfusiologist": "Transfusionista",
        "Trichologist": "Tricologista",
        "Urologist": "Urologista",
        "Pharmacist": "Farmacêutico",
        "Paramedic": "Paramédico",
        "Physiotherapist": "Fisioterapeuta",
        "Phlebologist":"Flebologista",
        "Phoniatrist": "Foniatra",
        "Phthisiatrician": "Tisiologista",
        "Surgeon": "Cirurgião",
        "Implant surgeon": "Cirurgião implantodontista",
        "Maxillofacial surgeon": "Cirurgião maxilofacial",
        "Embryologist": "Embriologista",
        "Endocrinologist": "Endocrinologista",
        "Endoscopist": "Endoscopista",
        "Epidemiologist": "Epidemiologista",
        "Epileptologist": "Epileptologista",
      },
    },
  },
};